import { Button, FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme
} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { spacing } from "@mui/system";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import FileInputLabel from "../../../components/FormElements/FileInputLabel";
import Api from "../../../helpers/api";
import {
    createSampleAcessioning,
    getClient, getDealer, getInstitute, getSampleAccessioning,
    updateSamplesAccessioning, uploadMediaFiles
} from "../../actions/GenomicsResearchAction";
import './index.sass';
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        toolbar: {
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 1),
            ...theme.mixins.toolbar,
        },
        content: {
            width: "80%",
            flexGrow: 21,
        },
        hoveItem: {
            cursor: "pointer",
        },
        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
    })
);
interface Props {
    getSampleAccessioning: any;
    updateSamplesAccessioning: any;
    createSampleAcessioning: any;
    samplesAccessioning: any;
    getClient: any;
    client: any;
    getInstitute: any;
    institute: any;
    getDealer: any;
    dealer: any;
    sampleData: any;
    onBoardingActionType: any;
    uploadMediaFiles: any;
    mediaUpload: any;
}
const StopsPlace: React.FC<Props> = ({
    getSampleAccessioning,
    updateSamplesAccessioning,
    createSampleAcessioning,
    getClient,
    client,
    getInstitute,
    institute,
    getDealer,
    dealer,
    sampleData,
    onBoardingActionType,

}) => {
    const classes = useStyles();
    const history = useHistory();
    const timer = useRef<any>(0);
    const [isEdit, setIsEdit] = useState<any>(false);
    const { id } = useParams<{ id: string }>();
    const [editId, setEditId] = useState<any>("");
    const [addMore, setAddMore] = useState<boolean>(false);
    const [uploading, setUploading] = useState<boolean>(false);
    const [sample, setSample] = useState<any>({
        initiationCall: false,
        initiationCallDate: "",
        poDate: "",
        poNumber: "",
        inspectionStatus: "",
        passedCount: 0,
        failedCount: 0,
        poCount: 0,
        qcReport: "",
        receivedCount: 0,
        remarks: "",
        comment: "",
        sifFile: "",
        additional: "",
        trfPo: "",
        type: "",
        otherType: undefined,
        scientist: undefined,
        institute: undefined,
        dealer: undefined
    });

    const [newSample, setNewSample] = useState<any>({
        passedCount: 0,
        receivedCount: 0,
        failedCount: 0,
        inspectionStatus: "",
        qcReport: "",
        sifFile: "",
    });

    const onSampleUpdate = (key: string, value: any) => {
        setSample({
            ...sample,
            [key]: value
        })
    }

    const onNewSampleUpdate = (key: string, value: any) => {
        setNewSample({
            ...newSample,
            [key]: value
        })
    }
    const fileSelectedHandler = async (e: React.ChangeEvent<{ files: any }>, type: any) => {
        const formData = new FormData();
        formData.append("file", e.target.files[0]);
        setUploading(true);
        Api.post("/media", formData).then((data: any) => {
            if (type === "qcReport" && isEdit) {
                setNewSample({
                    ...newSample,
                    [type]: data.path
                })
            } if (type === "sifFile" && isEdit) {
                setNewSample({
                    ...newSample,
                    [type]: data.path
                })
            } 
            else
                setSample({
                    ...sample,
                    [type]: data.path
                })
            setUploading(false);
        }).catch(() => {
            setUploading(false);
        });
    };
    const submitForm = async (e: any) => {
        e.preventDefault();
        // Generate submit data
        const submitData = {
            scientist: sample.scientist,
            institute: sample.institute,
            dealer: sample.dealer,
            type: sample.type,
            poCount: sample.poCount,
            trfPo: sample.trfPo,
            quotation: sample.quotation,
            additional: sample.additional,
            remarks: sample.remarks,
            comment: sample.comment,
            initiationCall: sample.initiationCall,
            poDate: sample.poDate === "" ? undefined : sample.poDate,
            poNumber: sample.poNumber,
            initiationCallDate: sample.initiationCallDate === "" ? undefined : sample.initiationCallDate,
            otherType: sample.otherType === "" ? undefined : sample.otherType,
        }

        // If new sample

        if (isEdit) {
            await updateSamplesAccessioning({ ...submitData, ...(addMore ? newSample : {}) }, sampleData?._id);
        } else {
            await createSampleAcessioning({
                ...submitData,
                passedCount: sample.passedCount,
                receivedCount: sample.receivedCount,
                failedCount: sample.failedCount,
                inspectionStatus: sample.inspectionStatus,
                qcReport: sample.qcReport,
                sifFile: sample.sifFile
            });
        }
        history.go(`/dashboard/gnre/samples`);
    };

    useEffect(() => {
        getSampleAccessioning();
        getClient();
        getInstitute();
        getDealer();
    }, []);

    useEffect(() => {
        if (onBoardingActionType === "Edit Onboard SampleAccessioning") {
            setEditId(sampleData?._id);
            setSample({
                ...sampleData,
                scientist: sampleData?.scientist?._id,
                institute: sampleData?.institute?._id,
                dealer: sampleData?.dealer?._id,
                scientistObj: sampleData?.scientist,
                instituteObj: sampleData?.institute,
                dealerObj: sampleData?.dealer,
                initiationCallDate: sampleData?.initiationCallDate ? sampleData?.initiationCallDate?.split("T")[0] : '',
                poDate: sampleData?.poDate ? sampleData?.poDate?.split("T")[0] : ''

            });
            setIsEdit(true);
        }
    }, [onBoardingActionType])
    return (
        <Grid container spacing={2}>
            <form onSubmit={submitForm} style={{ width: "100%" }}>
                <Paper style={{ margin: "70px auto", width: "90%", background: "#eff", marginTop: 10 }}>
                    <h2 style={{ fontWeight: "bold", paddingTop: "10px", paddingBottom: "10px", textAlign: "center" }}>Sample Details</h2>
                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="flex-end"
                        spacing={2}
                        style={{ margin: "1rem auto" }}
                    >
                        <Grid container spacing={2} style={{ marginLeft: 1 }}>
                            <Grid item xs={12} sm={4} md={3}>
                                <Autocomplete
                                    key={isEdit}
                                    disablePortal
                                    id="client_name"
                                    onChange={(event, newValue) => {
                                        onSampleUpdate("scientist", newValue ? newValue._id : "");
                                    }}
                                    defaultValue={{ _id: sample?.scientist, name: sample?.scientistObj?.name || "" }}
                                    options={client?.results || []}
                                    blurOnSelect
                                    disableClearable={sample?.scientist === undefined}
                                    getOptionLabel={(option: any) => `${option?.name}`}
                                    onInputChange={(event, newInputValue) => {
                                        clearTimeout(timer.current);
                                        timer.current = setTimeout(() => {
                                            getClient(`name=${newInputValue}`);
                                        }, 1000);
                                    }}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        className="input"
                                        label="Client"
                                        variant="outlined"
                                        placeholder="Select Client Name"
                                        fullWidth
                                    />}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <Autocomplete
                                    key={isEdit}
                                    disablePortal
                                    id="Institute"
                                    onChange={(event, newValue) => {
                                        onSampleUpdate("institute", newValue ? newValue._id : "");
                                    }}
                                    options={institute.results || ""}
                                    blurOnSelect
                                    disableClearable={sample?.institute === undefined}
                                    defaultValue={{ _id: sample?.institute, name: sample?.instituteObj?.name || "" }}
                                    getOptionLabel={(option: any) => `${option?.name}`}
                                    onInputChange={(event, newInputValue) => {
                                        clearTimeout(timer.current);
                                        timer.current = setTimeout(() => {
                                            getInstitute(`name=${newInputValue}`);
                                        }, 1000);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            className="input"
                                            label="Institute Name"
                                            placeholder="Select Institute Name"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <Autocomplete
                                    key={isEdit}
                                    disablePortal
                                    id="Dealer"
                                    onChange={(event, newValue) => {
                                        onSampleUpdate("dealer", newValue ? newValue._id : "");
                                    }}

                                    options={dealer.results || []}
                                    blurOnSelect
                                    disableClearable={sample?.dealer === undefined}
                                    defaultValue={{ _id: sample?.dealer, firmName: sample?.dealerObj?.firmName || "" }}
                                    getOptionLabel={(option: any) => `${option?.firmName}`}
                                    onInputChange={(event, newInputValue) => {
                                        clearTimeout(timer.current);
                                        timer.current = setTimeout(() => {
                                            getDealer(`name=${newInputValue}`);
                                        }, 1000);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            className="input"
                                            label="Dealer Name"
                                            placeholder="Select Dealer Name"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <FormControl style={{ width: "100%" }} className="input">
                                    <InputLabel>Sample Type*</InputLabel>
                                    <Select
                                        label="Sample Type"
                                        variant="outlined"
                                        className="input"
                                        fullWidth
                                        required
                                        value={sample.type || "none"}
                                        style={{ width: "100%", height: "40px" }}
                                        onChange={(e) => onSampleUpdate("type", e.target.value)}
                                    >
                                        <MenuItem value="none" disabled><em>Select Sample Type</em></MenuItem>
                                        <MenuItem value="DNA">DNA</MenuItem>
                                        <MenuItem value="RNA">RNA</MenuItem>
                                        <MenuItem value="Tissue">Tissue</MenuItem>
                                        <MenuItem value="Leaf">Leaf</MenuItem>
                                        <MenuItem value="Blood">Blood</MenuItem>
                                        <MenuItem value="Saliva">Saliva</MenuItem>
                                        <MenuItem value="Soil">Soil</MenuItem>
                                        <MenuItem value="Water">Water</MenuItem>
                                        <MenuItem value="Feaces">Feaces</MenuItem>
                                        <MenuItem value="Ch DNA">Ch-DNA</MenuItem>
                                        <MenuItem value="Plant Tissue">Plant Tissue</MenuItem>
                                        <MenuItem value="Animal Tissue">Animal Tissue</MenuItem>
                                        <MenuItem value="Cell Line">Cell Line</MenuItem>
                                        <MenuItem value="Others">Others</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {sample.type === "Others" && <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    className="input"
                                    label="Other Sample Type"
                                    type="text"
                                    fullWidth
                                    placeholder="Enter sample type"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={sample.otherType || ""}
                                    variant="outlined"
                                    onChange={(e) => onSampleUpdate("otherType", e.target.value)}
                                />
                            </Grid>}
                            <Grid item xs={12} sm={4} md={3}>
                                <FormControl style={{ width: "100%" }} className="input">
                                    <InputLabel>Project Intiation Call*</InputLabel>
                                    <Select
                                        className="input"
                                        label="Project Intiation Call"
                                        fullWidth
                                        aria-required
                                        variant="outlined"
                                        required
                                        value={sample.initiationCall || "none"}
                                        style={{ width: "100%", height: "40px" }}
                                        onChange={(e) => onSampleUpdate("initiationCall", e.target.value === "true")}
                                    >
                                        <MenuItem value="none"><em>Select</em></MenuItem>
                                        <MenuItem value="true">Yes </MenuItem>
                                        <MenuItem value="false">No</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {sample.initiationCall ?
                                <Grid item xs={12} sm={4} md={3}>
                                    <TextField
                                        key={isEdit}
                                        name="Initation_Call_Date"
                                        type="date"
                                        value={sample.initiationCallDate}
                                        className="input"
                                        label="Initation Call Date"
                                        variant="outlined"
                                        onChange={(e) => onSampleUpdate("initiationCallDate", e.target.value as string)}
                                        style={{ width: "100%" }}
                                        inputProps={{
                                            max: moment().format("YYYY-MM-DD"),
                                        }}
                                    />
                                </Grid>
                                : ""}
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    id="filled-number"
                                    className="input"
                                    label="No Of Samples(P/O)"
                                    type="number"
                                    fullWidth
                                    placeholder="Enetr Samples(P/O)"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={sample.poCount + ""}
                                    variant="outlined"
                                    required
                                    onChange={(e) => onSampleUpdate("poCount", Number(e.target.value))}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    name="Po_date"
                                    type="date"
                                    value={sample.poDate}
                                    className="input"
                                    label="PO Date"
                                    variant="outlined"
                                    onChange={(e) => onSampleUpdate("poDate", e.target.value as string)}
                                    style={{ width: "100%" }}
                                    inputProps={{
                                        max: moment().format("YYYY-MM-DD"),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    id="filled-number"
                                    className="input"
                                    label="PO No"
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={sample.poNumber + ""}
                                    variant="outlined"
                                    onChange={(e) => onSampleUpdate("poNumber", (e.target.value))}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} style={{marginTop:7}}>
                                <input
                                    disabled={uploading}
                                    className={classes.input}
                                    style={{
                                        width: "100%",
                                        marginTop: "0px",
                                        padding: "5px 14px",
                                        border: "1px solid rgba(0, 0, 0, 0.23)",
                                        borderRadius: "7px",
                                        fontSize: "0.8em"
                                    }}
                                    type="file"
                                    name="file"
                                    id="file"
                                    multiple
                                    onChange={(e: any) => fileSelectedHandler(e, "trfPo")}
                                />
                                <FileInputLabel label="PO" />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} style={{marginTop:5}}>
                                <input
                                    disabled={uploading}
                                    className={classes.input}
                                    style={{
                                        width: "100%",
                                        marginTop: "0px",
                                        padding: "5px 14px",
                                        border: "1px solid rgba(0, 0, 0, 0.23)",
                                        borderRadius: "5px",
                                        fontSize: "0.8em",
                                    }}
                                    type="file"
                                    name="file"
                                    id="file"
                                    onChange={(e: any) => fileSelectedHandler(e, "quotation")}
                                />
                                <FileInputLabel label="Quotation" />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} style={{marginTop:5}}>
                                <input
                                    disabled={uploading}
                                    className={classes.input}
                                    style={{
                                        width: "100%",
                                        marginTop: "0px",
                                        padding: "5px 14px",
                                        border: "1px solid rgba(0, 0, 0, 0.23)",
                                        borderRadius: "5px",
                                        fontSize: "0.8em"
                                    }}
                                    type="file"
                                    name="file"
                                    id="file"
                                    onChange={(e: any) => fileSelectedHandler(e, "additional")}
                                />
                                <FileInputLabel label="Additional File" />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="flex-start"
                            spacing={2}
                            style={{ margin: "4rem auto", background: "#eff" }}
                        >
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    id="filled-number"
                                    className="input"
                                    label="Samples Recevied"
                                    type="number"
                                    fullWidth
                                    placeholder="Enter Samples Recevied "
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={sample.receivedCount + ""}
                                    required
                                    variant="outlined"
                                    onChange={(e) => onSampleUpdate("receivedCount", Number(e.target.value))}

                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <FormControl style={{ width: "100%" }} className="input">
                                    <InputLabel>Sample Status*</InputLabel>
                                    <Select
                                        className="input"
                                        label="Sample Status"
                                        fullWidth
                                        aria-required
                                        variant="outlined"
                                        required
                                        value={sample.inspectionStatus || "none"}
                                        style={{ width: "100%", height: "40px" }}
                                        onChange={(e) => onSampleUpdate("inspectionStatus", e.target.value as string)}
                                    >
                                        <MenuItem value="none" disabled><em>Select Sample Status</em></MenuItem>
                                        <MenuItem value="Pass">Pass </MenuItem>
                                        <MenuItem value="Fail">Reject</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {sample.inspectionStatus === "Fail" ?
                                <Grid item xs={12} sm={4} md={3}>
                                    <TextField
                                        fullWidth
                                        id="outlined-basic"
                                        label="Remarks"
                                        variant="outlined"
                                        placeholder="Type Remarks"
                                        className="input"
                                        value={sample.remarks}
                                        onChange={(e) => onSampleUpdate("remarks", e.target.value)}
                                    />
                                </Grid>
                                : " "}
                            {sample.inspectionStatus === "Pass" ?
                                <>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <TextField
                                            id="filled-number"
                                            className="input"
                                            label="No Of Pass Samples"
                                            type="number"
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={sample.passedCount + ""}
                                            variant="outlined"
                                            required
                                            onChange={(e) => onSampleUpdate("passedCount", Number(e.target.value))}

                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <TextField
                                            id="filled-number"
                                            className="input"
                                            fullWidth
                                            label="No Of Fail Samples"
                                            type="number"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={sample.failedCount + ""}
                                            variant="outlined"
                                            onChange={(e) => onSampleUpdate("failedCount", Number(e.target.value))}

                                        />
                                    </Grid>
                                </>
                                : ""}
                            <Grid item xs={12} sm={6} md={3}>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                            </Grid>
                            {isEdit === true ?
                                <Grid item xs={12} sm={4} md={3}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        fullWidth
                                        onClick={() => setAddMore(!addMore)}
                                    >
                                        Add Samples
                                    </Button>
                                </Grid>
                                : ""}
                            {addMore &&
                                <>
                                    <Grid
                                        container
                                        direction="row"
                                        justify="space-between"
                                        alignItems="flex-start"
                                        spacing={2}
                                        style={{ margin: "1rem auto" }}>
                                        <Grid item xs={12} sm={4} md={3}>
                                            <TextField
                                                id="filled-number"
                                                className="input"
                                                label="Samples Recevied"
                                                type="number"
                                                fullWidth
                                                placeholder="Enter Samples Recevied "
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                value={newSample.receivedCount + ""}
                                                required
                                                variant="outlined"
                                                onChange={(e) => onNewSampleUpdate("receivedCount", Number(e.target.value))}

                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={3}>
                                            <FormControl style={{ width: "100%" }} className="input">
                                                <InputLabel>Sample Status</InputLabel>
                                                <Select
                                                    className="input"
                                                    label="Sample Status"
                                                    fullWidth
                                                    aria-required
                                                    variant="outlined"
                                                    required
                                                    value={newSample.inspectionStatus || "none"}
                                                    style={{ width: "100%", height: "40px" }}
                                                    onChange={(e) => onNewSampleUpdate("inspectionStatus", e.target.value as string)}
                                                >
                                                    <MenuItem value="none" disabled><em>Select Sample Status</em></MenuItem>
                                                    <MenuItem value="Pass">Pass </MenuItem>
                                                    <MenuItem value="Fail">Reject</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={3}>
                                            <TextField
                                                id="filled-number"
                                                className="input"
                                                label="No Of Pass Samples"
                                                type="number"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                value={newSample.passedCount + ""}
                                                variant="outlined"
                                                onChange={(e) => onNewSampleUpdate("passedCount", Number(e.target.value))}

                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={3}>
                                            <TextField
                                                id="filled-number"
                                                className="input"
                                                fullWidth
                                                label="No Of Fail Samples"
                                                type="number"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                value={newSample.failedCount + ""}
                                                variant="outlined"
                                                onChange={(e) =>
                                                    onNewSampleUpdate("failedCount", Number(e.target.value))
                                                }

                                            />
                                        </Grid>
                                    </Grid>
                                </>}
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="flex-start"
                        spacing={2}
                        style={{ margin: "1rem auto", background: "#eff", marginTop: "-45px" }}
                    >
                        <Grid item xs={12} sm={6} md={6}>
                            <TextField
                                id="filled-number"
                                className="input"
                                label="Comment"
                                fullWidth
                                value={sample.comment}
                                placeholder="type Comments"
                                variant="outlined"
                                onChange={(e) => onSampleUpdate("comment", e.target.value)}

                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <input
                                disabled={uploading}
                                className={classes.input}
                                style={{
                                    width: "100%",
                                    marginTop: "0px",
                                    padding: "5px 14px",
                                    border: "1px solid rgba(0, 0, 0, 0.23)",
                                    borderRadius: "5px",
                                    fontSize: "0.8em"
                                }}
                                type="file"
                                name="file"
                                id="file"
                                // multiple
                                onChange={(e: any) => fileSelectedHandler(e, "sifFile")}
                            />
                            <FileInputLabel label="SIF" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <input
                                disabled={uploading}
                                className={classes.input}
                                style={{
                                    width: "100%",
                                    marginTop: "0px",
                                    padding: "5px 14px",
                                    border: "1px solid rgba(0, 0, 0, 0.23)",
                                    borderRadius: "5px",
                                    fontSize: "0.8em"
                                }}
                                type="file"
                                name="file"
                                id="file"
                                onChange={(e: any) => fileSelectedHandler(e, "qcReport")}
                            />
                            <FileInputLabel label="Sample Condition Report" />
                        </Grid>
                    </Grid>
                    <Grid xs={12} style={{ textAlign: "center", padding: "20px" }}>
                        <Button
                            disabled={uploading}
                            color="primary"
                            variant="contained"
                            type="submit"
                            style={{ width: 250 }}
                        >
                            {uploading ? "Uploading..." : (isEdit ? "Update" : "Save")}
                        </Button>
                    </Grid>
                    {/* <Grid item xs={6} style={{ textAlign: "center", padding: "20px" }}>
                        <Button
                            color="secondary"
                            variant="contained"
                            style={{ width:100 }}
                        >
                            reset
                        </Button>
                    </Grid> */}
                </Paper>
            </form>
        </Grid >
    );
};
const mapStateToProps = (state: any) => ({
    samplesAccessioning: state.GenomicsCAReducer.samplesAccessioning,
    client: state.GenomicsCAReducer.client,
    institute: state.GenomicsCAReducer.institute,
    dealer: state.GenomicsCAReducer.dealer,
    mediaUpload: state.GenomicsCAReducer.mediaUpload,
});
export default connect(mapStateToProps, {
    getSampleAccessioning,
    updateSamplesAccessioning,
    createSampleAcessioning,
    getClient,
    getInstitute,
    getDealer,
    uploadMediaFiles,

})(StopsPlace);
